import { ReactNode, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import LoadingScreen from '@/components/ui/loading-screen';

interface ProtectedRouteProps {
  children: ReactNode;
}

export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading, refreshSession } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const attemptRefresh = async () => {
      if (loading) {
        try {
          await refreshSession();
        } catch (error) {
          console.error('[ProtectedRoute] Refresh error:', error);
        }
      }
    };

    void attemptRefresh();
  }, [loading, refreshSession]);

  if (loading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return (
      <Navigate
        to="/auth"
        replace
        state={{ returnUrl: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  }

  return <>{children}</>;
}
